<template>
  <div>
    <ProjectCopy></ProjectCopy>
  </div>
</template>

<script>
import ProjectCopy from "@/components/ProjectCopy/index.vue";
export default {
  components: {
    ProjectCopy,
  },
};
</script>

<style></style>
